import CloseIcon from "@mui/icons-material/Close";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { useTranslation } from "react-i18next";
function ErrorSummary(props: any) {
  const { t, i18n } = useTranslation();
  const { setOpen, fileErrors } = props;

  return (
    <div className="h-90v">
      <div className="flex flex-row items-center justify-between p-3 bg-neutral-100">
        <p>{t("Error records")}</p>
        <CloseIcon
          onClick={() => setOpen(false)}
          className="cursor-pointer pw-e2e-logsummarycloseicon"
        />
      </div>
      <Table>
        <TableHead>
          <TableRow className="!bg-neutral-50">
            <TableCell className="!text-neutral-600">
              {t("Row Number, Column Number")}
            </TableCell>
            <TableCell className="!text-neutral-600">
              "{t("BU Error Code")}
            </TableCell>
            <TableCell className="!text-neutral-600">
              {t("Error Text")}
            </TableCell>
            <TableCell className="!text-neutral-600">
              Error Description
            </TableCell>
            <TableCell className="!text-neutral-600">
              {t("Help Link")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {fileErrors.map((each: any) => (
            <TableRow>
              <TableCell>{each.number}</TableCell>
              <TableCell>{each.error_code}</TableCell>
              <TableCell>{each.error_text}</TableCell>
              <TableCell>{each.error_description}</TableCell>
              <TableCell>{each.help_link}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}

export default ErrorSummary;
